import Axios from "@/plugins/axios.ts";
import type {Source} from "@/domain/type/source.type.ts";
import type {SynchroFormData, SynchroHistory} from "@/domain/type/synchro.type.ts";
import type {AxiosResponse} from "axios";
import type {DemandResponse, GetEntityFieldsResponse, GetEntityResponse, GetRequestResponse} from "@/domain/type/synchro.api.type.ts";

class SynchroApi {
  demand(src1: Source, src2: Source, type: string, id: string | null): Promise<AxiosResponse<DemandResponse>> {
    if (null === id || id.length === 0) {
      return Axios.get(`/synchro/demand/${src1}_${src2}_${type}`);
    }
    return Axios.get(`/synchro/demand/${src1}_${src2}_${type}/${id}`);
  }

  getEntityFields(uuid: string): Promise<AxiosResponse<GetEntityFieldsResponse>> {
    return Axios.get(`/synchro/request/entity/${uuid}/fields`);
  }

  getRequest(requestUuid: string): Promise<AxiosResponse<GetRequestResponse>> {
    return Axios.get(`/synchro/request/${requestUuid}`);
  }

  getEntity(uuid: string): Promise<AxiosResponse<GetEntityResponse>> {
    return Axios.get(`/synchro/request/entity/${uuid}`);
  }

  refreshEntity(entityUuid: string): Promise<void> {
    return Axios.patch(`/synchro/entity/refresh`, {uuid: entityUuid});
  }

  applyEntity(uuid: string, fields: SynchroFormData = {}): Promise<AxiosResponse<void>> {
    return Axios.post(`/synchro/apply/entity`, {
      uuid: uuid,
      fieldList: fields
    });
  }

  getHistorySrc1(groupUid: string): Promise<AxiosResponse<{ block: { history: SynchroHistory[] } }>> {
    return Axios.get(`/synchro/request/history/src1/${groupUid}`);
  }

  getHistorySrc2(groupUid: string): Promise<AxiosResponse<{ block: { history: SynchroHistory[] } }>> {
    return Axios.get(`/synchro/request/history/src2/${groupUid}`);
  }

  linkEntityToOwner(entityUuid: string, ownerId: string) {
    return Axios.patch(`/synchro/link/${entityUuid}/${ownerId}`);
  }
}


export default new SynchroApi();
